module.exports = __webpack_public_path__ + "img/chart-breakout-circle.20f4688c.svg";